<template>
	<div>
		<loading v-if="!loaded"/>
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" style="text-align: center" v-if="loaded && gameList.length == 0">{{$store.state.lang.text.not_available[$store.state.lang.language]}}</div>
			<div class="md-layout-item md-xsmall-size-50 md-small-size-33 md-medium-size-25 md-size-20 margin-bottom-15" v-for="game in gameList">
				<div class="game-list" @click="openGame(game.hash)">
					<img class="game-list-image" :src="config.getGameImageUrl(game.hash)">
					<span>{{game.name}}</span>
				</div>
			</div>
		</div>
	</div>

</template>

<script>

	import { Datetime } from 'vue-datetime';

	export default {
		components: {

		},
		mounted() {
			window.scrollTo(0,0);
		},
		created() {
			this.getGame();
		},
		methods: {
			getGame() {
				this.$http.post(this.config.api + "/public/game/search", {
					text: "",
					provider: "",
					game_type: 2,
					offset: 0
				}).then(res => {
					if (res.body.status == 'success') {
						this.loaded = true;
						this.gameList= res.body.data
					}
				})
			},
			openGame(hash) {
				// this.$router.push("/play/" + hash);
				if(this.$store.state.authentication.loggedIn) {
					this.$store.state.authentication.loading = true;
					this.$http.get(this.config.api + "/user/authed/game/open/" + hash).then(res => {
						this.$store.state.authentication.loading = false;
						if (res.body.status == 'success') {
							// window.open(res.body.data.url, "_blank");
							this.$store.state.authentication.url = res.body.data.url;
						}
					})
				} else {
					this.$router.push("/login");
				}
			}
		},
		computed: {
		},
		data() {
			return {
				loaded: false,
				gameList: []
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Bet/Casino.vue